<div class="loading" *ngIf="ls.loading">
  <mat-spinner>
  </mat-spinner>
</div>
<nav class="navbar navbar-expand-lg navbar-dark fixed-top bg-fsp"  id="mainNav">
  <div class="container">
    <a class="navbar-brand " routerLink="/" (click)="saveScrollId('home')">
      <img src="assets/logo/logo.png" width="30" height="30" class="d-inline-block align-top" alt="">
      FS Personnel
    </a>
    <button mat-stroked-button data-toggle="collapse" data-target="#navbarResponsive" class="navbar-toggler navbar-toggler-right" type="button"  aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      <mat-icon>menu</mat-icon>
    </button>
    
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav text-uppercase ml-auto">
        <li class="nav-item">
          <a href="#home" class="nav-link p-0" onclick="javascript:void(0)"><a class="nav-link  " routerLink="/" (click)="saveScrollId('home')">home</a></a>
        </li>
        <li class="nav-item">
          <a href="#team" class="nav-link p-0" onclick="javascript:void(0)"><a class="nav-link  " routerLink="/"  (click)="saveScrollId('team')">Team</a></a>
        </li>
        <li class="nav-item">
          <a href="#about" class="nav-link p-0" onclick="javascript:void(0)"><a class="nav-link " routerLink="/"  (click)="saveScrollId('about')">About</a></a>
        </li>
        <li class="nav-item">
          <a href="#services" class="nav-link p-0" onclick="javascript:void(0)"><a class="nav-link " routerLink="/services"  (click)="saveScrollId('services')">Services</a></a>
        </li>
        <li class="nav-item">
          <a href="#advices" class="nav-link p-0" onclick="javascript:void(0)"><a class="nav-link " routerLink="/advices" (click)="saveScrollId('advices')">Advices</a></a>
        </li>
        <li class="nav-item">
          <a href="#jobs" class="nav-link p-0" onclick="javascript:void(0)"><a class="nav-link " routerLink="/jobs" (click)="saveScrollId('jobs')">Jobs</a></a>
        </li>
        <li class="nav-item">
          <a href="#contact" class="nav-link p-0" onclick="javascript:void(0)"><a class="nav-link" routerLink="/contact" (click)="saveScrollId('contact')">Contact</a></a>
        </li>
        <li class="nav-item" *ngIf="userService.user === undefined">
          <a href="#login" class="nav-link p-0" onclick="javascript:void(0)" ><a class="nav-link" routerLink="/login" (click)="saveScrollId('login')">Login</a></a>
        </li>
        <li class="dropdown nav-link" *ngIf="userService.user !== undefined">
          <a class="nav-link p-0 dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{userService.user !== undefined?userService.user.surname:''}}</a>
          <ul class="dropdown-menu" >
            <li><a routerLink="/profile">Profile</a></li>
            <li><a (click)="userService.logout()">Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div >
 <router-outlet></router-outlet>
</div>
<footer class="footer bg-light">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-4">
        <span class="copyright">Copyright &copy; FS Personnel 2020</span>
      </div>
      <div class="col-md-4">
        <ul class="list-inline social-buttons">
          <li class="list-inline-item">
            <a href="https://twitter.com/FS_PERSONNEL" target="blank">
              <i class="fa fa-twitter"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a href="https://www.facebook.com/FSPERSONNEL/" target="blank">
              <i class="fa fa-facebook-f"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a href="https://www.instagram.com/explore/locations/1457729571147170/fs-personnel/" target="blank">
              <i class="fa fa-instagram"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a href="https://www.linkedin.com/company/fs-personnel-recruitment/about/" target="blank">
              <i class="fa fa-linkedin-square"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-4">
        <a routerLink="/"><img src="assets/logo/full-logo.jpg" class="footer-logo"/></a>
        <!-- <ul class="list-inline quicklinks">
          <li class="list-inline-item">
            <a href="#">Privacy Policy</a>
          </li>
          <li class="list-inline-item">
            <a href="#">Terms of Use</a>
          </li>
        </ul> -->
      </div>
    </div>
  </div>
  <div class="warning-msg bg-fsp py-2"><span class="text-white">Please note this is not the official FSPersonnel website but a demo project, the offical website can be found on <a href="http://fspersonnel.co.za" target="blank">FSPersonnel.co.za</a></span></div>
</footer>
